export interface Theme {
    name: string;
    image: string;
    color: string;
}

export const THEMES = {
    SING: {
        name: 'Sing',
        image: '/sing_dubu.png',
        color: '#ead7f8' // Pastel purple
    },
    RAIN: {
        name: 'Rain',
        image: '/rain_dubu.png',
        color: '#b5e2fa' // Pastel blue
    },
    DANCE: {
        name: 'Dance',
        image: '/dance_dubu.png',
        color: '#f7d9c4' // Pastel orange
    },
    STUDY: {
        name: 'Study',
        image: '/study_dubu.png',
        color: '#d4e4bc' // Pastel green
    }
} as const;

export type ThemeKey = keyof typeof THEMES; 